const mutations = {
  setMasterProviders(state, masterProviders) {
    state.masterProviders = masterProviders;
  },
  setMasterProvider(state, masterProvider) {
    state.masterProvider = masterProvider
  },
};

export default mutations;